import React from "react";
import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useSeverity } from "hooks/severity-types/useSeverity";
import { SeverityIcon } from "components/SeverityIcon";

export const SeverityContainer = ({ severityId }) => {
  const { loading, error, severityName, colour } = useSeverity(severityId);

  if (loading) return <Typography>Loading...</Typography>;

  if (error) return <Typography>An error occurred</Typography>;

  return (
    <Container color={colour}>
      <SeverityIcon severityId={severityId} colour={colour} />
      <Typography>{severityName}</Typography>
    </Container>
  );
};

SeverityContainer.propTypes = {
  severityId: PropTypes.number
};

const Container = styled("div")`
  display: flex;
  flex-direction: row;
  border: 1px solid ${props => props.color};
  padding: ${props => props.theme.spacing(1)};
  gap: ${props => props.theme.spacing(1)};
  align-items: center;
  border-radius: 3px;
`;
